import {useEffect} from 'react';
import {ArrowLeft} from 'lucide-react';
import {Link} from 'react-router-dom';
import {Navbar} from './Navbar';
import {Footer} from './Footer';
import {useLanguage} from '../contexts/LanguageContext';

export function Impressum() {
    const {lang} = useLanguage();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Navbar/>
            <main className="min-h-screen bg-[#020817] pt-24 pb-20">
                <div className="max-w-3xl mx-auto px-4 md:px-8">
                    <Link
                        to="/"
                        data-testid="back-to-home"
                        className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-cyan-400 transition-colors mb-8"
                    >
                        <ArrowLeft className="w-4 h-4"/>
                        {lang === 'de' ? 'Zurück zur Startseite' : 'Back to Home'}
                    </Link>

                    <h1 className="text-4xl md:text-5xl font-bold text-white mb-2">
                        Impressum
                    </h1>
                    <div className="w-12 h-1 bg-cyan-500 rounded-full mb-10"/>

                    <div className="space-y-8 text-slate-300 leading-relaxed">
                        <section>
                            <h2 className="text-lg font-semibold text-white mb-3">
                                Angaben gemäß § 5 DDG
                            </h2>
                            <div className="bg-[#0f172a] border border-slate-800 rounded-xl p-5 space-y-1 text-sm">
                                <p>Philip Michalski</p>
                                <p>c/o Impressumservice Dein-Impressum</p>
                                <p>Stettiner Str. 41</p>
                                <p>35410 Hungen</p>
                                <p className="mt-4 text-yellow-400">
                                    <strong>Bitte versenden Sie keine Pakete an diese Adresse.</strong>
                                </p>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-lg font-semibold text-white mb-3">Kontakt</h2>
                            <div className="bg-[#0f172a] border border-slate-800 rounded-xl p-5 space-y-1 text-sm">
                                <p>E-Mail: <a href="mailto:info@hosting-community.de"
                                              className="text-cyan-400 hover:underline">info@hosting-community.de</a>
                                </p>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-lg font-semibold text-white mb-3">
                                Haftung für Inhalte
                            </h2>
                            <p className="text-sm">
                                Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten
                                nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als
                                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
                                Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
                                Tätigkeit hinweisen.
                            </p>
                            <p className="text-sm mt-3">
                                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
                                allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch
                                erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
                                Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
                                entfernen.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-lg font-semibold text-white mb-3">
                                Haftung für Links
                            </h2>
                            <p className="text-sm">
                                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
                                Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr
                                übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
                                Betreiber der Seiten verantwortlich.
                            </p>
                            <p className="text-sm mt-3">
                                Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
                                überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
                                Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
                                Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
                                Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-lg font-semibold text-white mb-3">Urheberrecht</h2>
                            <p className="text-sm">
                                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
                                dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
                                der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen
                                Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind
                                nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf
                                dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter
                                beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie
                                trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
                                entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige
                                Inhalte umgehend entfernen.
                            </p>
                        </section>
                    </div>
                </div>
            </main>
            <Footer/>
        </>
    );
}
